export default __webpack_public_path__ + "static/score-okay-401a010ef44f3f0f8c06725c37aa1680.svg";